<template>
    <requests @search="search" @paginate="setPage" @sort="setSort"
        :fetchIntervalRequestSearch="fetchIntervalRequestSearch" :onLoadReportPreview="fetchReport" :loading="pending"
        :sort="sort" :records="paginatedRecords" :total="totalRecords" :display="display" :page="page" />
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Requests from './Requests';

export default {
    name: 'requests-container',
    components: {
        Requests,
    },
    methods: {
        ...mapActions('requests', [
            'fetchRequestSearch',
            'fetchIntervalRequestSearch',
            'fetchReport',
            'setPage',
            'setSort',
            'search',
            'resetState',
        ]),
    },
    computed: {
        ...mapState('requests', ['page', 'display', 'sort', 'pending']),
        ...mapGetters('requests', ['paginatedRecords', 'totalRecords']),
    },
    created() {
        this.fetchRequestSearch()
    },
    destroyed() {
        this.resetState();
    },
}
</script>



// WEBPACK FOOTER //
// RequestsContainer.vue?73057a2b